<template>
    <el-container id="tab">
        <el-main>
            <el-tabs type="border-card" v-model="tabsName" class="tabs-card">
                <el-card shadow="never" class="form-box">
                    <div class="form-box-left">
                        <el-form :inline="true" class="query_form" ref="queryForm" :model="queryForm" label-position="right" size="small">
                            <el-form-item>
                                <span slot="label">制单日期</span>
                                <date-picker v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                                </date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-dropdown split-button placement="right" type="primary" @command="handleCommand" @click="toSelect()">
                                    查询
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="print">打印</el-dropdown-item>
                                        <el-dropdown-item command="export">导出</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <!-- <el-button type="primary" @click="toSelect">查询</el-button>
                                <el-button type="success" @click="exportTable">导出</el-button> -->
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
                <el-tab-pane label="订货" name="A">
                    <div slot="label" style="position: relative;">
                        <span>订货</span>
                        <el-badge :max="999" :value="total"></el-badge>
                    </div>
                    <div class="tab_pane_table">
                        <el-table ref="table" :row-key="getTableRowKey" v-loading="tableIsLoading" :data="tableList" highlight-current-row stripe border height="100%" max-height="100%" @row-dblclick="handleTableDBClick" @cell-mouse-enter="cellMouseEnter" @cell-mouse-leave="cellMouseLeave" @filter-change="filterMethod" show-summary :summary-method="getSummaries">
                            <el-table-column type="selection" width="36" reserve-selection></el-table-column>
                            <el-table-column type="index" width="50"></el-table-column>
                            <el-table-column label="单号" prop="billNo" width="182">
                                <template slot="header" slot-scope="scope">
                                    <el-popover placement="bottom" trigger="click" ref="popover_billNo" @show="popoverShow('billNo')">
                                        <div class="query_btn_group">
                                            <el-input v-model="queryForm.billNo.selected" placeholder="输入单号搜索" clearable></el-input>
                                            <el-button type="text" @click="tableFilter('billNo')">筛选</el-button>
                                        </div>
                                        <div slot="reference" :class="['reference', queryForm.billNo.isFilter ? 'highlight' : '' ]"><label>单号</label><i class='el-icon-arrow-down'></i></div>
                                    </el-popover>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.billNo }}</span>
                                    <el-button-group :class="{showBtn: !scope.row.isShowBtn}">
                                        <!-- <el-tag key="isMove" style="color: rgba(0, 206, 209, 1); background-color: rgba(0, 206, 209, 0.1)" size="mini"></el-tag> -->
                                    </el-button-group>
                                    <el-button-group :class="{ showBtn: scope.row.isShowBtn }">
                                        <el-button type="text" size="mini" @click="editTable(scope.row, 'copy')" v-if="btnPower.isCopy == 'Y'&&scope.row.meetType == 'A'">复制</el-button>
                                        <el-button v-show="btnPower.isRedStrik == 'Y' && power.isAllowRed == 'Y' && scope.row.billStatus == 'B'" style="margin-left: 6px; color: #F56C6C;" type="text" size="mini" @click="redBillNo(scope.row.billNo)">红冲</el-button>
                                        <el-button v-show="btnPower.isEdit == 'Y' && scope.row.billStatus == 'A'" style="margin-left: 6px; color: #67C23A;" type="text" size="mini" @click="editTable(scope.row, 'edit')">编辑</el-button>
                                        <el-button v-show="btnPower.isCancel == 'Y' && scope.row.billStatus == 'A'" style=" margin-left: 6px; color: #909399;" type="text" size="mini" @click="cancelBillNo(scope.row.billNo)">作废</el-button>
                                    </el-button-group>
                                </template>
                            </el-table-column>
                            <el-table-column label="客户" prop="customerName" min-width="140">
                                <template slot="header" slot-scope="scope">
                                    <el-popover placement="left" trigger="click" ref="popover_customerID" @show="popoverShow('customerID')">
                                        <div class="query_btn_group">
                                            <select-multiple :select-data="queryForm.customerID" is-scroll isClear isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
                                            <el-button type="text" @click="tableFilter('customerID')">筛选</el-button>
                                        </div>
                                        <div slot="reference" :class="['reference', queryForm.customerID.isFilter ? 'highlight' : '' ]"><label>客户</label><i class='el-icon-arrow-down'></i></div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column label="订货会" prop="salOrderMeetName" width="100">
                                <template slot="header" slot-scope="scope">
                                    <el-popover placement="bottom" trigger="click" ref="popover_salOrderMeetID" @show="popoverShow('salOrderMeetID')">
                                        <div class="query_btn_group">
                                            <select-multiple :select-data="queryForm.salOrderMeetID" is-scroll isClear></select-multiple>
                                            <el-button type="text" @click="tableFilter('salOrderMeetID')">筛选</el-button>
                                        </div>
                                        <div slot="reference" :class="['reference', queryForm.salOrderMeetID.isFilter ? 'highlight' : '' ]"><label>订货会</label><i class='el-icon-arrow-down'></i></div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" prop="qtyFormat" width="100">
                            </el-table-column>
                            <el-table-column label="金额" prop="totalAmt" width="80">
                            </el-table-column>
                            <el-table-column label="收款信息" prop="collectionInfo" width="100">
                            </el-table-column>
                            <el-table-column label="制单人员" prop="entryUserName" width="100">
                                <template slot="header" slot-scope="scope">
                                    <el-popover placement="bottom" trigger="click" ref="popover_entryUserID" @show="popoverShow('entryUserID')">
                                        <div class="query_btn_group">
                                            <select-multiple :select-data="queryForm.entryUserID" is-scroll isClear></select-multiple>
                                            <el-button type="text" @click="tableFilter('entryUserID')">筛选</el-button>
                                        </div>
                                        <div slot="reference" :class="['reference', queryForm.entryUserID.isFilter ? 'highlight' : '' ]"><label>制单人员</label><i class='el-icon-arrow-down'></i></div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column label="审核人" prop="recordedUserName" width="100">
                                <template slot="header" slot-scope="scope">
                                    <el-popover placement="bottom" trigger="click" ref="popover_recordedUserID" @show="popoverShow('recordedUserID')">
                                        <div class="query_btn_group">
                                            <select-multiple :select-data="queryForm.recordedUserID" is-scroll isClear></select-multiple>
                                            <el-button type="text" @click="tableFilter('recordedUserID')">筛选</el-button>
                                        </div>
                                        <div slot="reference" :class="['reference', queryForm.recordedUserID.isFilter ? 'highlight' : '' ]"><label>审核人</label><i class='el-icon-arrow-down'></i></div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column label="审核时间" prop="recordedDateTime" width="86"></el-table-column>
                            <el-table-column label="单据来源" prop="isFromVehicle" width="80" :filters="[{ value: 'Y', text: '手机' }, { value: 'N', text: '电脑' }]" :filter-multiple="false" column-key="isFromVehicle">
                                <!-- <template slot-scope="{ row }">
                                    <span>{{[{ value: 'Y', text: '手机' }, { value: 'N', text: '电脑' }].filter(i => i.value == row.isFromVehicle)[0].text}}</span>
                                </template> -->
                            </el-table-column>
                            <el-table-column label="备注" prop="remark" min-width="140px">
                                <!-- <template slot="header" slot-scope="scope">
                                    <el-popover placement="bottom" trigger="click" ref="popover_remark" @show="popoverShow('remark')">
                                        <div class="query_btn_group">
                                            <el-input v-model="queryForm.remark.selected" placeholder="输入备注搜索" clearable></el-input>
                                            <el-button type="text" @click="tableFilter('remark')">筛选</el-button>
                                        </div>
                                        <div slot="reference" :class="['reference', queryForm.remark.isFilter ? 'highlight' : '' ]"><label>备注</label><i class='el-icon-arrow-down'></i></div>
                                    </el-popover>
                                </template> -->
                            </el-table-column>
                            <el-table-column label="状态" prop="billStatus" fixed="right" width="80" :filters="billStatusList" column-key="billStatus" :filtered-value="[ 'A', 'B', 'C']">
                                <template slot-scope="scope">
                                    <el-tag style="cursor: text;" :type="billStatusList.filter(item => item.value == scope.row.billStatus)[0].type">{{ billStatusList.filter(item => item.value == scope.row.billStatus)[0].text }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="打印" prop="printCount" width="110" fixed="right"
                              :filters="[{ value: 'Y', text: '已打印' }, { value: 'N', text: '未打印' }]" :filter-multiple="false" column-key="isPrint">
                                <template slot-scope="scope">
                                    <el-button class="my-button" v-if="btnPower.isPrint == 'Y' && !power.customPrint" size="mini" plain @click="printTable(scope.row.billNo)">打印(<span :style="{ color: scope.row.printCount == '0' ? '#E6A23C' : '' }">{{ scope.row.printCount }}</span>)</el-button>
                                    <template v-if="btnPower.isPrint == 'Y' && power.customPrint">
                                        <el-dropdown class="printBtn" @command="mouldPrintBillNo($event, scope.row)" split-button :type="scope.row.isPrint == 'Y' ? 'info' : 'warning'" @click="mouldPrintBillNo('', scope.row)">打印(<span :style="{ color: scope.row.printCount == '0' ? '#E6A23C' : '' }">{{ scope.row.printCount }}</span>)
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item :command="item.id" v-for="item in mouldObject['DHD']" :key="item.id">{{ item.templateName }}</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </template>
                                  <!-- <el-button-group class="showBtn" style="display: flex; align-items: center; justify-content: center;">
                                    <el-button style="color: #606266;" type="text" size="mini" @click="printTable(scope.row.billNo)">打印</el-button>
                                    <el-divider direction="vertical"></el-divider>
                                    <span :style="{ color: scope.row.printCount == '0' ? '#E6A23C' : '' }">{{ scope.row.printCount }}</span>
                                  </el-button-group> -->
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </el-tab-pane>
            </el-tabs>
        </el-main>
        <el-drawer size="70%" custom-class="detail_drawer" :visible.sync="drawerIsShow" destroy-on-close @close="drawerClose" :with-header="false">
            <orderDetailDialog ref="orderDetailDialog" :visible.sync="drawerIsShow" :tabs-active-arr="tabsActiveArr" :location-search="locationSearch" :power="power" :btn-power="btnPower" @operateBill="operateBill"></orderDetailDialog>
        </el-drawer>
    </el-container>
</template>

<script>
import datePicker from '@/components/common/datePicker.vue'
import orderDetailDialog from '@/components/common/orderDetailDialog.vue'
import { g_getKeyByValue, g_getValueByKey, printSalOrder } from '@/assets/js/printByPage.js' 
import { toRawType, getResultArray, toFixedRe, pickerOptions, getAddDate, getNowFormatDate, exportExcelCommonForVue, printForBillNoLayer } from '@/assets/js/common.js'
export default {
    components: {
        datePicker,
        orderDetailDialog
    },
    name: 'SalOrderItemOrder',
    mixins: [selectMultipleTableColumnListCommonMixins],
    data() {
        let billStatusList = [
            { value: 'A', text: '待审核', type: 'warning' },
            { value: 'B', text: '已审核', type: 'success' },
            { value: 'C', text: '已红冲', type: 'danger' },
            { value: 'D', text: '已作废', type: 'info' }
        ]
        return {
            queryForm: {
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
                billNo: { selected: '', isFilter: false },
                remark: { selected: '', isFilter: false },
                recordedUserID: { submitName: 'recordedUser', selected: {}, isFilter: false, valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: `请选择审核人`, request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 10, isFitterEnabled: 'N' }, text: '', value: '' } },
                customerID: { submitName: 'customer', selected: {}, isFilter: false, valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: `请选择客户`, request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 10, isFitterEnabled: 'N', customerType: 'S' }, text: '', value: '' } },
                entryUserID: { submitName: 'entryUser', selected: {}, isFilter: false, valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择制单人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 10, isFitterEnabled: 'N' }, text: '', value: '' } },
                salOrderMeetID: { submitName: 'salOrderMeet', selected: {}, isFilter: false, valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择订货会', request: { url: '/Account/dataSearchVue/selectOrderMeetForVue.html', type: 'post', params: { page: 1, size: 10, orderMeetType: 'A' }, text: '', value: '' } },
            },
            pickerOptions: pickerOptions,
            tableList: [],
            tabsName: 'A',
            tableIsLoading: false,
            billStatusList: billStatusList,
            params: {
                page: 1,
                size: 20,
                billStatus: "'A', 'B', 'C'",
                beginDate: getAddDate(-3),
                endDate: getNowFormatDate(),
                billSearchType: 'DHD'
            },
            total: 0,
            drawerIsShow: false,
            locationSearch: {},
            tabsActiveArr: ['A', 'empty', 'showFuJian'],
            isGetPower: false,
            btnPower: {},
            power: {
                isStrikePerOrder: '', // 是否按单清欠 Y/N
                isSecondBatch: '', // 是否启用小老板模式 Y/N
                isDisabledBillDate: '', // 是否禁用单据日期 Y/N
                splitPayAndReturnPrePay: '', // 退货预收和欠款预收是否分开 Y/N
                brandArrear: '', // 是否分品牌欠款和预收款 Y/N
                isShowProductionDate: '', // 是否显示显示生产日期 Y/N
                isShowFlavor: '', // 是否显示多口味 Y/N
                isShowItemCode: '', // 是否显示商品编号 Y/N
                isShowInvBarCode: '', // 是否显示小单位条码 Y/N
                allowCostPrice: '', // 是否允许查看成本价 Y/N
                allowRecord: '', // 是否直接记账，N 保存草稿，Y直接记账
                payType: '', // 收款方式 混合收款(A)、优先现金(B)、优先预收(C)、优先欠款(D)
                isDefaultCollectionMethod: '', // 默认支付方式
                isMoreCollection: '', // 是否允许混合收款，默认为N(不允许)
                isEnableProductDate: '', // 是否可以修改生产日期 Y/N,
                customPrint: '' // 富文本多模板打印
            },
            sum: {},
            locationSearch: {
                tag: 'DHD'
            },
            msgDomList: [],
            mouldObject: {}
        }
    },
    computed: {
        // queryitem() {
        //     let tempItem = {}
        //     Object.values(this.queryForm).forEach(item => {
        //         if (toRawType(item.selected) == 'Array') {
        //             if (item.submitName == 'billDate') {
        //                 tempItem['beginDate'] = item.selected[0] || ''
        //                 tempItem['endDate'] = item.selected[1] || ''
        //                 return false
        //             }
        //             tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        //         } else if (toRawType(item.selected) == 'Object') {
        //             if (['salOrderMeet', 'customer', 'salesman'].includes(item.submitName)) {
        //                 tempItem[item.submitName + 'ID'] = item.selected.value || ''
        //                 tempItem[item.submitName + 'Name'] = item.selected.text || ''
        //                 return false
        //             }
        //             tempItem[item.submitName] = item.selected.value || ''
        //         }
        //     })
        //     return tempItem
        // },
    },
    created() {
        this.getPower()
        this.getBtnPower()
        this.getTableList()
        this.getRichTextMouldPrint()
    },
    methods: {
        async getAccount() {
            const { data: res } = await $http({ url: '/Account/dataSearchVue/getFeeTypeList.html', type: 'post', params: Qs.stringify(this.params) })
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.accountList = JSON.parse(res.result.data)
        },
        async getBtnPower() {
            this.isGetPower = false
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectFunctionButtonAuth.html', this.Qs.stringify({ menuID: 32 }))
            this.isGetPower = true
            res.result = JSON.parse(res.result)
            this.btnPower = JSON.parse(res.result.data)
            console.log(this.btnPower)
        },
        async getPower() {
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColAndAuthByFuncCode.html', this.Qs.stringify({ funcCode: 201 }))
            this.isGetPower = true
            res.result = JSON.parse(res.result)
            this.power = JSON.parse(res.result.data)
        },
        //获取富文本的多模板打印模板
        async getRichTextMouldPrint() {
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/printsetCustomized/selectPrintset', {})
            if (res.code != '0') return this.$message.error(res.message)
            res.data.forEach(item => {
                let key = g_getKeyByValue(item.printSetType)
                if (key) {
                    this.mouldObject[key] = item.sonLists
                }
            })
            console.log(res.data)
            console.log(this.mouldObject)
        },
        // 获取表格数据
        async getTableList(isPagination) {
            // if (!isPagination && !['PKD', 'SKD', 'SKDA'].includes(this.args.billSearchType)) {
            //     this.getSummary()
            //     this.getSalesmanSummary(true)
            // }
            this.tableIsLoading = true
            let url = '/Account/billSearchVue/selectBillHeadList.html'
            const { data: res } = await this.$http.post(url, this.Qs.stringify(this.params))
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.tableList = JSON.parse(res.result.data)
            this.total = res.result.total || 0
            this.sum = JSON.parse(res.result.sum)[0]
            console.log(this.sum)
            this.tableIsLoading = false
        },
        toSelect() {
            this.params.beginDate = this.queryForm.billDate.selected[0] || ''
            this.params.endDate = this.queryForm.billDate.selected[1] || ''
            this.getTableList()
        },
        // 改变每页显示的条数
        handleSizeChange(newSize) {
            this.params.size = newSize
            this.getTableList(true)
        },
        // 翻页
        handleCurrentChange(newPage) {
            this.params.page = newPage
            this.getTableList(true)
        },
        // 表格行的唯一值
        getTableRowKey(row) {
            return row.billNo
        },
        // 单元格鼠标划入事件
        cellMouseEnter(row) {
            this.$set(row, 'isShowBtn', true)
        },
        // 单元格鼠标划出事件
        cellMouseLeave(row) {
            this.$set(row, 'isShowBtn', false)
        },
        // 筛选框打开时触发事件
        popoverShow(tag) {
            const popover = this.$refs['popover_' + tag]
            popover.$nextTick(() => {
                popover.$children[0].focus()
            })
        },
        // 其他自定义筛选
        tableFilter(tag) {
            this.$refs['popover_' + tag].doClose()
            let item = this.queryForm[tag]
            if (Array.isArray(item.selected)) {
                this.params[tag] = item.selected.map(element => ("'" + element.value + "'")).join(',')
                item.isFilter = item.selected.length ? true : false
            } else {
                this.params[tag] = item.selected
                item.isFilter = item.selected ? true : false
            }
            this.params.page = 1
            console.log(this.params)
            this.getTableList()
        },
        // 状态与打印筛选
        filterMethod({ billStatus, isPrint, billBackType, billType, isFromVehicle, payType, typeID }) {
            if (billStatus) {
                this.params.billStatus = billStatus.map(item => ("'" + item + "'")).join(",") || ''
            }
            if (isPrint) {
                this.params.isPrint = isPrint[0] || ''
            }
            // if (billBackType) {
            //     this.params.billBackType = billBackType[0] || ''
            // }
            if (isFromVehicle) {
                this.params.isFromVehicle = isFromVehicle[0] ? ("'" + isFromVehicle[0] + "'") : ''
            }
            // if (billType) {
            //     this.params.billType = billType[0] || ''
            // }
            // if (payType) {
            //     this.params.payType = payType[0] || ''
            // }
            // if (typeID) {
            //     this.params.typeID = typeID[0] || ''
            // }
            this.params.page = 1
            this.getTableList()
        },
        // 重置
        resetTableFilter() {
            this.queryForm.billDate = [getAddDate(-3), getNowFormatDate()]
            for (key in this.queryForm) {
                this.params[key] = this.queryForm[key].selected = ''
                this.queryForm[key].isFilter = false
            }
            let { table } = this.$refs
            table.clearFilter()
            table.columns[table.columns.length - 2].filteredValue = ['A', 'B', 'C']
        },
        // 红冲
        async redBillNo(billNo, type) {
            const confirmResult = await this.$confirm('此操作为红冲操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消红冲')
            const loading = this.$loading({
                lock: true,
                text: '红冲中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = '/Account/salOrderItemForVue/updateRedStrikForVue.html'
            const { data: res } = await this.$http.post(url, this.Qs.stringify({ billNo: billNo }))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            if (type == 1) this.drawerIsShow = false
            this.getTableList()
        },
        // 作废
        async cancelBillNo(billNo, type) {
            const confirmResult = await this.$confirm('此操作为作废操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消作废')
            const loading = this.$loading({
                lock: true,
                text: '作废中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = '/Account/salOrderMeetVue/cancelSalOrderMeet.html'
            const { data: res } = await this.$http.post(url, this.Qs.stringify({ billNo: billNo }))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            if (type == 1) this.drawerIsShow = false
            this.getTableList()
        },
        // 复制与编辑
        editTable({ billNo }, tag) {
            console.log(billNo, tag)
            let width = top.document.browser.availiframeWidth.value,
                height = top.document.browser.availiframeHeight.value
            top.addPanel('订货录单', `/templates/vue-account/dist/index.htm#/salOrderItemOrder?billNo=${ billNo }&tag=${ tag }`, width, height, true)
        },
        // 导出
        exportTable() {
            if (!this.tableList.length) return this.$message.error('请至少有一个单据')
            let element = this.$refs['table']
            let tempArr = element.$children.map(item => {
                if (item.property == 'isCollapse') {
                    return [
                        { label: '实收', prop: 'payAmt' },
                        { label: '欠款', prop: 'arrearAmt' }
                    ]
                } else {
                    return {
                        label: item.label,
                        prop: item.prop
                    }
                }
            }).filter(item => (item.prop || Array.isArray(item))).flat()
            let url = ''
            if (this.params.billSearchType == 'XSD') {
                url = '/Account/salConsignVue/exportSalConsignList.html'
            } else if (this.params.billSearchType == 'PKD') {
                url = '/Account/InvCheckVue/exportItemCheckExcelHeadList.html'
            } else {
                url = '/Account/billSearchVue/exportBillHeadList.html'
            }
            console.log(this.$root.locationSearch)
            // exportExcelCommonForVue(this.params, tempArr, this.params.billSearchType != 'XSD' ? '/Account/billSearchVue/exportBillHeadList.html' : '/Account/salConsignVue/exportSalConsignList.html')
            exportExcelCommonForVue(this.params, tempArr, url)
        },
        // 打印与导出
        handleCommand (command) {
            this.$nextTick(() => {
                if (command == 'export') {
                    this.exportTable()
                } else {
                    this.printTable()
                }
            })
        },
        // 打印
        printTable(billNo) {
            let billNos = billNo ? "'" + billNo + "'" : this.$refs['table'].selection.map(item => ("'" + item.billNo + "'")).join(',')
            if (!billNos) return this.$message.error('请至少有一个单据')
            console.log(this.power.customPrint);
            if (this.power.customPrint == 'Y') {
                this.mouldPrintBillNo('', { billType: '', billNo: billNo ? billNo : this.$refs['table'].selection.map(item => item.billNo) })
            } else {
                let url = `/Account/salOrderMeetVue/printOrderMeetList.html?billNo=${ billNos }`
                printForBillNoLayer({ url, title: '打印' }, () => { this.getTableList() })
            }
        },
        mouldPrintBillNo(command, { billNo, billType = '', sourceBillNo }) {
            billType = g_getValueByKey('DHD')
            if (!billType) return
            let msgDom = this.$loading({
                lock: true,
                text: '打印启动中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.3)'
            });
            this.msgDomList.push(msgDom)
            let params = { billType, billNos: Array.isArray(billNo) ? billNo : [billNo], callback: this.printComplete }
            if (command) {
                params.templateId = command
            }
            if (billType === 'CHD') {
                params.sourceBillNos = [sourceBillNo]
            }
            // printSalOrder('', billType, [str], command, this.printComplete)
            printSalOrder(params)
        },
        printComplete() {
            if (this.msgDomList && this.msgDomList.length) {
                this.msgDomList.forEach(item => {
                    item.close && item.close()
                })
                this.msgDomList = []
            }
            this.getTableList()
        },
        // 表格双击事件
        handleTableDBClick(row) {
            let { billNo } = row
            this.drawerIsShow = true
            this.$nextTick(() => {
                let orderDetailDialog = this.$refs['orderDetailDialog']
                // 获取单据详情事件
                orderDetailDialog.getImageList({ billNo: billNo })
                orderDetailDialog.getDetailInfo({ billNo: billNo, billType: 'DHD' })
                orderDetailDialog.getBarandArrearDetailInfo({ billNo: billNo, billType: 'DHD' })
            })
        },
        drawerClose() {
            this.$refs['orderDetailDialog'].drawerClose()
        },
        getSummaries(param) {
            const { columns } = param;
            const sums = [];
            for (let key in this.sum) {
                columns.forEach((column, index) => {
                    if (index == 2) {
                        sums[index] = "合计";
                        return;
                    }
                    if (column.property == key && key != 'remark') {
                        sums[index] = this.sum[key];
                        return;
                    }
                });
            }
            this.$nextTick(() => {
                this.$refs["table"].doLayout();
            });
            return sums;
        },
        operateBill({ name, billNo, tag }) {
            if (name == 'red') {
                this.redBillNo(billNo, 1)
            } else if (name == 'cancel') {
                this.cancelBillNo(billNo, 1)
            } else {
                this.editTable({ billNo: billNo }, tag)
            }
        }
    }
}
</script>
<style scoped lang="less">
:deep(.el-button.my-button){
    border: 1px solid #d0d0d0;
    color: #333;
}
:deep(.printBtn) {
    height: 32px;
    .el-button {
        padding: 0 6px;
        line-height: 30px;
    }
    .el-button.el-button--warning {
        background-color: #fdf6ec;
        border-color: #faecd8;
        color: #e6a23c;
    }
    .el-button.el-button--info {
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
    }
    .el-dropdown__caret-button{
        height: 32px;
    }
}
.el-loading-mask .el-loading-spinner i{
    /* color: #FFC559; */
    color: #fff;
}
.el-loading-mask .el-loading-spinner .el-loading-text{
    color: #fff;
    font-size: 16px;
}
#tab {

    .content {
        height: calc(100% - 100px - 2px);
    }

    .el-aside {
        /deep/.el-card__header {
            span {
                color: #333;
                font-size: 14px;
            }
        }
    }

    &>.el-main {
        padding: 0 0 0 12px;

        .tabs-card {
            height: calc(100% - 2px);

            /deep/.el-badge__content {
                position: absolute;
                top: -20px;
                right: -20px;
            }
        }

        /deep/.el-tabs__content {
            padding: 0 12px;
            height: calc(100% - 40px - 1px);

            .el-tab-pane {
                height: calc(100% - 56px - 12px - 24px);
                margin: 12px 0;
            }
        }

        ::v-deep .el-card {
            margin-top: 12px;

            .el-card__body {
                height: calc(100% - 24px);
                padding: 12px;

                .query_form {
                    position: relative;
                    display: flex;

                    .query_form_item {
                        position: relative;
                        flex: 1;
                    }

                    .el-form-item {
                        margin-bottom: 0;
                    }
                }
            }
        }

        /deep/ .el-table--scrollable-x .el-table__body-wrapper {
            z-index: 2;
        }


        .tab_pane_table {
            height: calc(100% - 32px);

            /deep/.el-table {
                td,
                th {
                    padding: 0;
                }

                td{
                    height: 50px;
                }

                .cell {
                    padding: 0 2px;
                }

                th:first-child .cell {
                    padding-left: 10px;
                }

                .el-table-column--selection {
                    .cell {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
    }

    .border {
        border-top: 1px #E4E7ED solid;
    }

    .cell-p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}

.el-button-group {
    display: none;
    height: 0;
}

.showBtn {
    display: inline-block;
    height: 26px;
}

.hideBtn {
    display: none;
}

.query_btn_group {
    display: flex;
    align-items: center;
}

.query_btn_group .el-button {
    // margin-left: 6px;
    // color: #606266;
    margin-left: 8px;
    color: white;
    width: 40px;
    height: 24px;
    background: #409EFF;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    padding: 0 10px;
    font-size: 12px;
}

.query_btn_group .el-button:hover {
    // color: #409EFF;
}

.reference {
    cursor: pointer;
}

.reference.highlight label {
    color: #409EFF;
}
</style>